export const buildNormalizedAuthContextState = ({
  normalizedAuthState = {},
  previousBillingStatus = null,
} = {}) => ({
  user: normalizedAuthState.user || null,
  household: normalizedAuthState.household || null,
  onboardingComplete: normalizedAuthState.onboardingComplete === true,
  onboardingStep: normalizedAuthState.onboardingStep || 1,
  billingStatus: normalizedAuthState.billingStatus || previousBillingStatus,
  features: normalizedAuthState.features || {},
});

export const buildLoginAuthContextState = ({
  tokens = {},
  userData = null,
  householdData = null,
  onboardingData = null,
  billingStatus = null,
  features = {},
} = {}) => ({
  accessToken: tokens.accessToken || null,
  refreshToken: tokens.refreshToken || null,
  user: userData,
  household: householdData,
  onboardingComplete: onboardingData?.completed === true,
  onboardingStep: onboardingData?.currentStep || 1,
  billingStatus: billingStatus || null,
  features: features || {},
});

export const normalizeAuthenticatedRequestEndpoint = ({
  url,
  baseUrl,
} = {}) => {
  let endpoint = url;
  let normalizedBasePath = baseUrl;

  if (typeof normalizedBasePath === 'string' && normalizedBasePath.startsWith('http')) {
    try {
      normalizedBasePath = new URL(normalizedBasePath).pathname;
    } catch (_error) {
      normalizedBasePath = baseUrl;
    }
  }

  if (typeof url === 'string' && url.startsWith('http')) {
    try {
      const parsed = new URL(url);
      endpoint = `${parsed.pathname}${parsed.search}`;
    } catch (_error) {
      endpoint = url;
    }
  }

  if (
    typeof normalizedBasePath === 'string'
    && typeof endpoint === 'string'
    && normalizedBasePath !== '/'
    && endpoint.startsWith(normalizedBasePath)
  ) {
    endpoint = endpoint.slice(normalizedBasePath.length);
    if (!endpoint.startsWith('/')) endpoint = `/${endpoint}`;
  }

  return endpoint;
};
